import { Navigate } from 'react-router-dom'

import { Spinner } from '@/components/ui'
import { appRoutes } from '@/constants'
import { useAuth } from '@/providers/auth-provider'

export function DashboardRedirect() {
  const { isAuthenticated, isLoading, dashboard, redirectPath } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <Spinner size="lg" label="Routing to your portal..." />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to={appRoutes.auth.login} replace />
  }

  if (dashboard && dashboard !== 'dashboard') {
    return <Navigate to={redirectPath} replace />
  }

  return null
}